import { useState } from 'react';

const parseIntOrBlank = (val) => {
  if (!val || isNaN(val)) {
    return ""
  } else {
    return parseInt(val)
  }
}

const useComplexBilling = (initialValue, extraFields = []) => {
  const [complex, setComplex] = useState(initialValue);
  const update = (i) => (field, transform=((x)=>(x))) => (value) => {
    setComplex(
      complex.map((elt, idx)=> {
        if ( idx !== i ) {
          return elt
        } else {
          return { ...elt, [field]: transform(value) }
        }
      })
    )
  }
  const extraDefaultObject = () => {
    let res = {}
    extraFields.forEach((elt)=>{
      res[[elt.name]]= elt.defaultValue
    })
    return res
  }
  const updateValue = (i) => {
    return update(i)("value", (x)=>(parseFloat(x)))
  }
  const updateFrom = (i) => {
    return update(i)("from", (x)=>(parseIntOrBlank(x)))
  }
  const updateTo = (i) => (value) => {
    setComplex(
      complex.map((elt, idx)=> {
        if (( idx === i )){
          return { ...elt, to: parseInt(value) }
        } else if ( idx === (i + 1) ) {
          //Update next from as well
          return { ...elt, from: parseInt(value) }
        } else {
          return elt
        }
      })
    )
  }
  const add = ()=>{
    setComplex([
      ...complex,
      {from: complex.at(-1).to, to: "", value: null, ...extraDefaultObject()}
    ])
  }
  const pop = ()=>{
    setComplex(
      [
        ...complex.slice(0,-2),
        { ...complex.at(-2), to: "" }
      ]
    )
  }
  return { complex, setComplex, updateFrom, updateTo, updateValue, update, add, pop  }
}

export default useComplexBilling